<template>
  <div :key="reRender">
    <div v-if="isSingEmpty">
      <DesertMessage
        class="bg-neutro-200 rounded"
        :mainTitle="$t('message.documentDetail.sign.empty.title')"
        :mainContent="$t('message.documentDetail.sign.empty.content')"
      />
    </div>
    <div v-else>
      <div class="pb-8">
        <zt-input
          disabled
          outlined
          :label="$t('message.documentDetail.sign.date')"
          v-model="signModel.fecha"
        />
      </div>
      <div class="pb-8">
        <zt-input
          disabled
          outlined
          :label="$t('message.documentDetail.sign.type')"
          v-model="signModel.tipo_firma"
        />
      </div>
      <div class="pb-8">
        <zt-input
          disabled
          outlined
          :label="$t('message.documentDetail.sign.finger')"
          v-model="signModel.finger_print"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DesertMessage from '@/components/generics/DesertMessage404.vue'

export default {
  name: 'Sign',
  components: { DesertMessage },
  inject: ['stateDetailStore'],
  data() {
    return {
      signModel: {
        fecha: '',
        tipo_firma: '',
        finger_print: ''
      },
      reRender: 0
    }
  },
  computed: {
    isSingEmpty() {
      const propertiesToEvaluate = ['fecha', 'tipo_firma']
      return !propertiesToEvaluate.every((key) => Boolean(this.signModel[key]))
    }
  },
  created() {
    this.signModel = {
      ...this.stateDetailStore.detail.sign,
      fecha: this.formatDate(this.stateDetailStore.detail.sign.fecha)
    }
    this.reRender += 1
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      return moment(date).format('DD/MM/YY HH:mm:ss')
    }
  }
}
</script>

<style scoped>
.bg-neutro-200 {
  background-color: #ebebeb;
}
</style>
